import { Container } from "./styles/styled";

const SuccessModal = (props) => {
  return (
    <Container>
      <div className="popup-container-background">
        <div className="delete-exercise-popup-container">
          <div>
            <h2>Felicitaciones!</h2>
          </div>
          <iframe src="https://lottie.host/embed/3b4fb994-5456-40c2-b84b-78d1d3672c99/UZfyboQlU8.lottie"></iframe>
          <div className="flex_center_space-between delete-exercise-popup-buttons-container onlyButton">
            <a className="btn-primary" href={props.linkTo}>
              Aceptar
            </a>
          </div>
        </div>
      </div>
    </Container>
  );
};
export default SuccessModal;
